module.exports = __webpack_public_path__ + "img/7a22f4a.png";